import type { CatalogQualityStatus } from '../../catalog/types';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { QUALITY_LABELS } from '../lib/qualityLabels';

export function FichaStatusBadge({
    status,
    size = 'md',
    className,
}: {
    status?: string | null;
    size?: 'sm' | 'md';
    className?: string;
}) {
    const key = (status && status in QUALITY_LABELS ? status : 'draft') as CatalogQualityStatus;
    return (
        <span data-ficha-status={key} className={className}>
            <StatusBadge status={key} size={size} />
        </span>
    );
}
